import React from "react";
import Form, { FormItem } from "../../../../components/Form";
import { useString as s } from "../../../../components/StringProvider";
import PropTypes from "prop-types";
import { validate } from "email-validator";
import { EmailInput } from "../../../../components/Input";
import ButtonGroup from "../../../../components/ButtonGroup";
import NewButton from "../../../../components/NewButton";
import SelectRoles from "./SelectRoles";

const UserForm = ({
  form,
  onFinish,
  submitButtonText,
  children,
  emailDisabled
}) => {
  const emailValidation = s(
    "accessManagement.page.userForm.email.validation",
    "Please input a valid email"
  );
  const emailPlaceholder = s(
    "accessManagement.page.userForm.email.placeholder",
    "Your email"
  );
  const roleText = s("accessManagement.page.userForm.role", "User role(s)");
  const emailText = s("accessManagement.page.userForm.email", "Email");
  const tooltipText = s(
    "accessManagement.page.userForm.tooltip",
    "The User role is required and cannot be removed. You can assign multiple roles to a User."
  );

  return (
    <Form form={form} layout="vertical" onFinish={onFinish} name={"userForm"}>
      <FormItem
        name="email"
        label={emailText}
        rules={[
          () => ({
            validator(_, value) {
              if (!validate(value)) {
                return Promise.reject(new Error(emailValidation));
              }

              return Promise.resolve();
            }
          })
        ]}
      >
        <EmailInput placeholder={emailPlaceholder} disabled={emailDisabled} />
      </FormItem>
      <FormItem tooltip={tooltipText} label={roleText} name="roleIds">
        <SelectRoles />
      </FormItem>
      <FormItem>
        <ButtonGroup>
          <NewButton type={"submit"} data-cy={"edit-form-save"}>
            {submitButtonText}
          </NewButton>
          {children}
        </ButtonGroup>
      </FormItem>
    </Form>
  );
};

UserForm.propTypes = {
  form: PropTypes.object.isRequired,
  onFinish: PropTypes.func.isRequired,
  submitButtonText: PropTypes.string.isRequired,
  emailDisabled: PropTypes.bool
};

UserForm.defaultProps = {
  emailDisabled: false
};

export default UserForm;
